import React, { useState } from 'react';

import { navigate } from '@reach/router';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

import { logout } from '../../../../../state/actions/user';
import getRoleLandingPage from '../../../../../utils/getRoleLandingPage';
import avatarImg from '../../../../../images/avatar.svg';

const styles = () => ({
  emailLabel: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'right',
    color: '#6a27e8',
    width: '110px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  user: {
    backgroundColor: '#ffffff',
    color: '#6a27e8',
    width: '100%',
    height: '270px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '22px 0',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    width: '80px',
    height: '80px',
  },
  avatarBtn: {
    width: '45px',
    height: '45px',
  },
  username: {
    fontFamily: 'Raleway',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#6a27e8',
    textAlign: 'left',
    marginBottom: '12px',
  },
  email: {
    fontFamily: 'Raleway',
    fontSize: '12px',
    textAlign: 'left',
    color: '#bfd0e1',
    fontWeight: 500,
    marginBottom: '12px',
  },
  profileCta: {
    backgroundColor: '#ffffff',
    color: '#6a27e8',
    border: '2px solid #6a27e8',
    textTransform: 'none',
    width: '105px',
    borderRadius: '16px',
    '&:hover': {
      border: '2px solid #6a27e8',
      background: '#6a27e8',
      color: '#ffffff',
    },
  },
  profileCtaLabel: {
    fontFamily: 'Raleway',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  signOut: {
    marginTop: '12px',
    backgroundColor: '#ffffff',
    color: '#6a27e8',
    border: 'none',
    textTransform: 'none',
    width: '100%',
    borderRadius: '16px',
    '&:hover': {
      border: 'none',
      background: '#6a27e8',
      color: '#ffffff',
    },
  },
  signOutLabel: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-start',
  },
});

const Profile = ({ classes, username, email, roles, hide, signOut }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = url => {
    navigate(url);
    handleClose();
  };

  const handleSignOut = () => {
    handleClose();
    signOut();
  };

  if (hide) return null;

  return (
    <>
      <span className={classes.emailLabel}>{email}</span>
      <Avatar className={classes.avatarBtn} onClick={handleClick}>
        U
      </Avatar>

      <Popover
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.user}>
          <div className={classes.detailsContainer}>
            <Avatar
              alt="user-image"
              src={avatarImg}
              className={classes.avatar}
            />
            <div className={classes.details}>
              <div className={classes.username}>{username}</div>
              <div className={classes.email}>{email}</div>
              <Button
                variant="outlined"
                color="primary"
                className={classes.profileCta}
                onClick={() => handleNavigation(getRoleLandingPage(roles))}
                classes={{
                  label: classes.profileCtaLabel,
                }}
              >
                see profile
              </Button>
            </div>
          </div>
          <div>
            <Divider />
            <Button
              variant="outlined"
              color="primary"
              className={classes.signOut}
              onClick={handleSignOut}
              classes={{
                label: classes.signOutLabel,
              }}
            >
              Sign out
            </Button>
          </div>
        </div>
      </Popover>
    </>
  );
};

const getUserName = state => {
  const firstname = get(state, ['user', 'firstname'], '');
  const lastname = get(state, ['user', 'lastname'], '');

  return `${firstname} ${lastname}`;
};

const mapStateToProps = state => ({
  email: state.user.email,
  roles: get(state, ['user', 'roles'], []),
  hide: isEmpty(state.user.userId),
  username: getUserName(state),
});

const mapDispatchToProps = dispatch => ({
  signOut: () => dispatch(logout()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Profile));
